module.exports = __webpack_public_path__ + "static/media/background.d53fed8c.jpg";